/**
 * Url定数
 */
export class PcUrl {
  /** Base */
  public static readonly Dashboard: string = "/dashboard";

  /** ホーム(家族連絡) */
  public static readonly HomeForFamilies: string = "/home-for-families";
  /** ホーム(待機者管理) */
  public static readonly HomeForWaiters: string = "/home-for-waiters";
  /** ホーム(他事業所連携) */
  public static readonly HomeForOtherOffice: string = "/home-for-other-office";

  /**
   * 利用者一覧
   *
   * #Topic:
   * デフォルトのアクティブクラスのマッチングの振る舞いは包含的なマッチになる。
   * 例えば、現在のパスが /a/ または /a から始まる限りは、<router-link to="/a"> にアクティブクラスが適用されます。
   * .router-link-activeクラスを使うために、各メニューの基底画面は/listなどはつけず、以下のようにしている
   */
  public static readonly ResidentList: string = "/resident";
  /** 利用者登録 */
  public static readonly ResidentRegister: string = "/resident/register";
  /** 連携システムから利用者登録 */
  public static readonly ResidentRegisterForCooperationSystem: string = "/resident/register/cooperation-system";
  /** 利用者一括登録 */
  public static readonly ResidentMultipleRegister: string = "/resident/multiple/register";
  /** 利用者詳細 */
  public static readonly ResidentDetail: string = "/resident/detail";
  /** 利用者編集 */
  public static readonly ResidentEdit: string = "/resident/edit";
  /** 利用者からの家族編集 */
  public static readonly ResidentFamilyEdit: string = "/resident/fmaily/edit";
  /** 利用者グループ一覧 */
  public static readonly ResidentGroupList: string = "/resident/group";
  /** 利用者グループ登録 */
  public static readonly ResidentGroupRegister: string = "/resident/group/register";
  /** 利用者グループ編集 */
  public static readonly ResidentGroupEdit: string = "/resident/group/edit";
  /** 利用者グループメンバー編集 */
  public static readonly ResidentGroupMemberEdit: string = "/resident/group/member/edit";

  /** 家族ユーザー一覧 */
  public static readonly FamilyList: string = "/family-user";
  /** 家族メールユーザー登録 */
  public static readonly FamilyRegister: string = "/family-user/register";
  /** 家族メールユーザー編集 */
  public static readonly FamilyEdit: string = "/family-user/edit";

  /** 施設関係者グループ一覧 */
  public static readonly OtherUserGroupList: string = "/other-user-group";
  /** 施設関係者グループ登録 */
  public static readonly OtherUserGroupRegister: string = "/other-user-group/register";
  /** 施設関係者グループ編集 */
  public static readonly OtherUserGroupEdit: string = "/other-user-group/edit";
  /** 施設関係者グループ種類一覧 */
  public static readonly OtherUserGroupTypeList: string = "/other-user-group/type/list";
  /** 施設関係者グループ種類編集 */
  public static readonly OtherUserGroupTypeEdit: string = "/other-user-group/type/edit";
  /** 施設関係者グループメンバー登録 */
  public static readonly OtherUserGroupMemberRegister: string = "/other-user-group/member/register";
  /** 施設関係者グループメンバー編集 */
  public static readonly OtherUserGroupMemberEdit: string = "/other-user-group/member/edit";

  /** 介護記録一覧 */
  public static readonly CareimageList: string = "/careimage";
  /** 介護記録登録 */
  public static readonly CareimageRegister: string = "/careimage/register";
  /** 介護記録一括登録 */
  public static readonly CareimageMultipleRegister: string = "/careimage/multiple-register";

  /** 写真印刷依頼 */
  public static readonly PictureList: string = "/picture/list";

  /** イベント一覧 */
  public static readonly EventList: string = "/event";
  /** イベント登録 */
  public static readonly EventRegister: string = "/event/register";
  /** イベント編集 */
  public static readonly EventEdit: string = "/event/edit";
  /** イベント返信登録 */
  public static readonly EventReplyRegister: string = "/event/reply/register";
  /** イベント返信編集 */
  public static readonly EventReplyEdit: string = "/event/reply/edit";

  /** 面会予約一覧 */
  public static readonly ReservationList: string = "/reservation";
  /** 訪問面会スケジュール、代理予約登録 */
  public static readonly ReservationSchedules: string = "/reservation/schedule";
  /** 訪問面会設定 */
  public static readonly ReservationSettings: string = "/reservation/settings";
  /** 面会スケジュールテンプレート一覧 */
  public static readonly ReservationScheduleTemplateList: string = "/reservation/schedule/templates";
  /** 面会スケジュールテンプレート登録 */
  public static readonly ReservationScheduleTemplateRegister: string = "/reservation/schedule/templates/register";
  /** 面会スケジュールテンプレート編集 */
  public static readonly ReservationScheduleTemplateEdit: string = "/reservation/schedule/templates/edit";

  /** 外出外泊届け一覧 */
  public static readonly OutingList: string = "/outings";
  /** 外出外泊届け詳細 */
  public static readonly OutingDetail: string = "/outings/detail";
  /** 外出外泊届け登録 */
  public static readonly OutingRegister: string = "/outings/register";
  /** 外出外泊届け編集 */
  public static readonly OutingEdit: string = "/outings/edit";
  /** 外出外泊届け設定 */
  public static readonly OutingSetting: string = "/outings/setting";

  /** メッセージ送信 */
  public static readonly SendMessage: string = "/send-messages";
  /** メッセージ送信設定変更 */
  public static readonly SendMessageSettingEdit: string = "/send-messages/setting-edit";

  /** メッセージ送信テンプレート */
  public static readonly SendMessageTemplateList: string = "/send-messages/template/list";
  /** メッセージ送信テンプレート登録 */
  public static readonly SendMessageTemplateRegister: string = "/send-messages/template/register";
  /** メッセージ送信テンプレート編集 */
  public static readonly SendMessageTemplateEdit: string = "/send-messages/template/edit";

  /** 宛先グループ一覧 */
  public static readonly SendMessageGroupList: string = "/send-message-groups/list";
  /** 宛先グループ登録 */
  public static readonly SendMessageGroupRegister: string = "/send-message-groups/register";
  /** 宛先グループ編集 */
  public static readonly SendMessageGroupEdit: string = "/send-message-groups/edit";
  /** 宛先グループメンバー編集 */
  public static readonly SendMessageGroupMemberEdit: string = "/send-message-groups/member/edit";

  /** 文書送付一覧 */
  public static readonly SendDocumentList: string = "/send-document";
  /** 文書送付登録 */
  public static readonly SendDocumentRegister: string = "/send-document/register";
  /** 文書送付編集 */
  public static readonly SendDocumentEdit: string = "/send-document/edit";
  /** 文書送付詳細 */
  public static readonly SendDocumentDetail: string = "/send-document/detail";
  /** 文書送付カテゴリー一覧 */
  public static readonly SendDocumentCategoryList: string = "/send-document/category/list";
  /** 文書送付カテゴリー編集 */
  public static readonly SendDocumentCategoryEdit: string = "/send-document/category/edit";
  /** 文書送付一覧 */
  public static readonly SendDocumentTemplateList: string = "/send-document/template/list";
  /** 文書送付一覧 */
  public static readonly SendDocumentTemplateRegister: string = "/send-document/template/register";
  /** 文書送付一覧 */
  public static readonly SendDocumentTemplateEdit: string = "/send-document/template/edit";

  /** 受信メッセージ */
  public static readonly ReceiveMessageList: string = "/receive-message/list";
  /** 受信メッセージ設定 */
  public static readonly ReceiveMessageSetting: string = "/receive-message/setting";

  /** 家族の使用状況 */
  public static readonly FamilyMessageList: string = "/families-message/list";

  /** 活動予定・履歴 */
  public static readonly Report: string = "/report";

  /** アンケート一覧 */
  public static readonly QuestionnaireList: string = "/questionnaires";
  /** アンケート登録 */
  public static readonly QuestionnaireRegister: string = "/questionnaires/register";
  /** アンケート編集 */
  public static readonly QuestionnaireEdit: string = "/questionnaires/edit";
  /** アンケート詳細 */
  public static readonly QuestionnaireDetail: string = "/questionnaires/detail";

  /** 安否確認一覧 */
  public static readonly SafetyConfirmList: string = "/safety-confirm";
  /** 安否確認登録 */
  public static readonly SafetyConfirmRegister: string = "/safety-confirm/register";
  /** 安否確認テンプレート(家族)編集 */
  public static readonly FamilySafetyConfirmTemplateEdit: string = "/safety-confirm/family/template/edit";
  /** 安否確認(家族)詳細 */
  public static readonly FamilySafetyConfirmDetail: string = "/safety-confirm/family/detail";
  /** 安否確認テンプレート(施設関係者)編集 */
  public static readonly OtherUserSafetyConfirmTemplateEdit: string = "/safety-confirm/other-user/template/edit";
  /** 安否確認(施設関係者)メッセージ送信 */
  public static readonly SendOtherUserSafetyConfirm: string = "/safety-confirm/other-user/send-messages";
  /** 安否確認(施設関係者)詳細 */
  public static readonly OtherUserSafetyConfirmDetail: string = "/safety-confirm/other-user/detail";
  /** 安否確認(施設関係者)回答詳細 */
  public static readonly OtherUserSafetyConfirmAnswers: string = "/safety-confirm/other-user/answers";

  /** ユーザー情報変更 */
  public static readonly AccountEdit: string = "/account/edit";
  /** マニュアル */
  public static readonly ManualList: string = "/manual";
  /** HitomeQコネクトについて */
  public static readonly About: string = "/about";

  /** 問い合わせ一覧 */
  public static readonly SupportList: string = "/support";
  /** 問い合わせ登録 */
  public static readonly SupportRegister: string = "/support/register";
  /** 問い合わせFAQ */
  public static readonly SupportFaqList: string = "/support/faq";
  /** 問い合わせマニュアル */
  public static readonly SupportManualList: string = "/support/manual";

  /** お知らせ */
  public static readonly NotificationList: string = "/notification";
  /** お知らせ詳細 */
  public static readonly NotificationDetail: string = "/notification/detail";

  /** 待機者一覧 */
  public static readonly WaiterList: string = "/waiters";
  /** 待機者一覧ダウンロード */
  public static readonly WaiterListDownload: string = "/waiters/download";
  /** 待機者登録 */
  public static readonly WaiterRegister: string = "/waiters/register";
  /** 待機者詳細 */
  public static readonly WaiterDetail: string = "/waiters/detail";
  /** 待機者変更申請 */
  public static readonly WaiterChangeRequest: string = "/waiters/change-request";
  /** 待機者編集 */
  public static readonly WaiterEdit: string = "/waiters/edit";
  /** 待機者経過履歴登録 */
  public static readonly WaiterProgressHistoryRegister: string = "/waiters/progress-history/register";
  /** 待機者経過履歴編集 */
  public static readonly WaiterProgressHistoryEdit: string = "/waiters/progress-history/edit";
  /** 待機者家族登録 */
  public static readonly WaiterFamilyRegister: string = "/waiters/families/register";
  /** 待機者家族登録 */
  public static readonly WaiterFamilyEdit: string = "/waiters/families/edit";
  /** 待機者管理の設定 */
  public static readonly WaiterSetting: string = "/waiters/setting";

  /** 待機者メッセージ送信 */
  public static readonly WaiterSendMessage: string = "/waiter-send-messages";
  /** 待機者メッセージ一覧 */
  public static readonly WaiterSendMessageTemplateList: string = "/waiter-send-messages/templates";
  /** 待機者メッセージ登録 */
  public static readonly WaiterSendMessageTemplateRegister: string = "/waiter-send-messages/templates/register";
  /** 待機者メッセージ編集 */
  public static readonly WaiterSendMessageTemplateEdit: string = "/waiter-send-messages/templates/edit";
  /** 待機者メッセージ一覧 */
  public static readonly WaiterSendMessageSetting: string = "/waiter-send-messages/settings";

  /** 待機者受信メッセージ */
  public static readonly WaiterReceiveMessageList: string = "/waiter-receive-message/list";
  /** 待機者受信メッセージ設定 */
  public static readonly WaiterReceiveMessageSetting: string = "/waiter-receive-message/setting";

  /** フォロワー */
  public static readonly FollowerList: string = "/followers";

  /** 施設見学 */
  public static readonly InspectionReservationList: string = "/inspection-reservations";
  /** 施設見学登録 */
  public static readonly InspectionReservationRegister: string = "/inspection-reservations/register";
  /** 施設見学編集 */
  public static readonly InspectionReservationEdit: string = "/inspection-reservations/edit";

  /** 入所募集問い合わせ */
  public static readonly RecruitmentContactList: string = "/recruitment-contacts";
  /** 入所募集問い合わせ登録 */
  public static readonly RecruitmentContactRegister: string = "/recruitment-contacts/register";
  /** 入所募集問い合わせ編集 */
  public static readonly RecruitmentContactEdit: string = "/recruitment-contacts/edit";

  /** 他事業所連携 連携施設詳細 */
  public static readonly OtherOfficeFacilityDetail: string = "/home-for-other-office/facility-detail";
  /** 他事業所連携情報一覧 */
  public static readonly OtherOfficeConnectionList: string = "/home-for-other-office/list";
  /** 他事業所連携情報編集 */
  public static readonly OtherOfficeConnectionEdit: string = "/home-for-other-office/edit";
  /** 他事業所連携 メッセージ */
  public static readonly OtherOfficeMessages: string = "/other-office-send-messages";
  /** 他事業所連携 オンライン会議 */
  public static readonly OtherOfficeOnlineMeetings: string = "/other-office-online-meetings";
  /** 他事業所連携 オンライン会議登録 */
  public static readonly OtherOfficeOnlineMeetingRegister: string = "/other-office-online-meetings/register";
  /** 他事業所連携 オンライン会議編集 */
  public static readonly OtherOfficeOnlineMeetingEdit: string = "/other-office-online-meetings/edit";
  /** 他事業所連携 オンライン会議詳細 */
  public static readonly OtherOfficeOnlineMeetingDetail: string = "/other-office-online-meetings/detail";
  /** 他事業所連携 空床情報 */
  public static readonly OtherOfficeRoomSchedules: string = "/other-office-room-schedules";
  /** 他事業所連携 救急搬送一覧 */
  public static readonly OtherOfficeEmergencyTransports: string = "/other-office-emergency-transports";
  /** 他事業所連携 救急搬送登録 */
  public static readonly OtherOfficeEmergencyTransportRegister: string = "/other-office-emergency-transports/register";
  /** 他事業所連携 救急搬送詳細 */
  public static readonly OtherOfficeEmergencyTransportDetail: string = "/other-office-emergency-transports/detail";
  /** 他事業所連携 救急搬送設定 */
  public static readonly OtherOfficeEmergencyTransportSetting: string = "/other-office-emergency-transports/setting";

  /** 施設 */
  public static readonly Facility: string = "/facility";
  /** 施設編集 */
  public static readonly FacilityEdit: string = "/facility/edit";
  /** 部屋一覧 */
  public static readonly RoomList: string = "/room/list";
  /** 部屋登録 */
  public static readonly RoomRegister: string = "/room/register";
  /** 部屋編集 */
  public static readonly RoomEdit: string = "/room/edit";
  /** 部屋一括登録 */
  public static readonly RoomMultipleRegister: string = "/room/multiple/register";
  /** 空床一覧 */
  public static readonly RoomScheduleList: string = "/room-schedule";
  /** 空床、利用者編集 */
  public static readonly RoomScheduleResidentEdit: string = "/room-schedule/resident/edit";
  /** 空室／空床情報の設定画面 */
  public static readonly RoomScheduleSetting: string = "/room-schedule/setting";
  /** 家族の使用機能 */
  public static readonly PermittedFunctionList: string = "/permitted-function";
  /** 家族の使用機能の変更 */
  public static readonly PermittedFunctionEdit: string = "/permitted-function/edit";
  /** 家族の使用機能(個別)確認・変更 */
  public static readonly FamilyPermittedFunctionList: string = "/family-permitted-function";
  /** 家族の使用機能(個別)確認・登録時設定 */
  public static readonly DefaultFamilyPermittedFunctionEdit: string = "/family-permitted-function/default/edit";
  /** 施設関係者の使用機能 */
  public static readonly OtherUserPermittedFunctionList: string = "/other-user-permitted-function";
  /** 施設関係者の使用機能の変更 */
  public static readonly OtherUserPermittedFunctionEdit: string = "/other-user-permitted-function/edit";
  /** 家族・施設関係者のLINEbot操作の通知設定 */
  public static readonly NotificationSettingEdit: string = "/notification-setting/edit";
  /** 一般ユーザー情報管理(一覧) */
  public static readonly StandardAccountList: string = "/account/standard/list";
  /** 一般ユーザー情報登録 */
  public static readonly StandardAccountRegister: string = "/account/standard/register";
  /** 一般ユーザー情報編集 */
  public static readonly StandardAccountEdit: string = "/account/standard/edit";
  /** システム連携一覧画面 */
  public static readonly CooperationSystemList: string = "/cooperation-system/list";
  /** プラン */
  public static readonly Plan: string = "/plan";
  /** 解約 */
  public static readonly Terminate: string = "/terminate";
}
